import type { Route } from "./+types/pricing-route";
import { Pricing } from "./components/Pricing/Pricing";
import {
  generateSeoMeta,
  generateBreadcrumbSchema,
} from "~/common/utils/seo-meta";

export function meta({}: Route.MetaArgs) {
  return [
    ...generateSeoMeta({
      title: "Тарифні плани - Brandly",
      description:
        "Оберіть тарифний план Brandly, який підходить для вашого бізнесу. Від безкоштовного плану до корпоративних рішень для контролю торгових марок.",
      keywords: [
        "brandly",
        "брендлі",
        "тарифи",
        "ціни",
        "плани",
        "підписка",
        "торгові марки",
        "вартість brandly",
      ],
      canonicalUrl: "/pricing",
    }),
    generateBreadcrumbSchema([
      { name: "Головна", url: "/" },
      { name: "Тарифи", url: "/pricing" },
    ]),
  ];
}

export default function PricingRoute() {
  return <Pricing />;
}
